import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import swal from "sweetalert";
import { motion } from "framer-motion";
import Modal from "../../../myfin_v2/elements/Modal";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import commoncss from "../../../myfin_v2/css/common.module.css";
import dropdowncss from "../../../myfin_v2/css/dropdown.module.css";
import InputGroup from "../../../myfin_v2/elements/InputGroup";
import { Button } from "../../../myfin_v2/elements/Button";
import { ReactComponent as DownIcon } from "../../../myfin_v2/assets/icons/down_arrow.svg";
import { ReactComponent as UpIcon } from "../../../myfin_v2/assets/icons/up_arrow.svg";
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as CircleCheckIcon } from "../../../myfin_v2/assets/icons/circle_check.svg";
import { ReactComponent as PlusIcon } from "../../../myfin_v2/assets/icons/plusprimary.svg";
import { addTBNote, mapLedger } from '../../Services/ApiHandler';
import {
  updateGroupings,
  updateLedgers,
  getBCTbRows
} from "../../../redux/actions/BookClosure/actionBookClosure";


const card = {
    position: "fixed",
    bottom: "3%",
    right: "2%",
    width: "300px",
    // height:'55px',
    backgroundColor: "white",
    zIndex: "99",
    borderRadius: "2px",
    boxShadow: "5px 5px 15px rgba(0, 0, 0, 0.3)",
    // boxShadow: '5px 10px #888888'
};
const action = {
    borderRadius: "2px",
    height: "50px",
    backgroundColor: "var(--clr-bg)",
    zIndex: "99",
    display: "flex",
    alignItems: "center",
};
const form = {
    borderRadius: "2px",
    height: "170px",
    backgroundColor: "white",
    zIndex: "99",
};

const TbMultiSelect = ({ show, onClose, groupings, selectedLedgers, bookClosureTbId }) => {

    const dispatch = useDispatch();

    const [menu, setMenu] = useState(true);
    const [selectedFs, setSelectedFs] = useState("");
    const [selectedNoteGroup, setSelectedNoteGroup] = useState("");
    const [selectedSubGroup, setSelectedSubGroup] = useState("");
    const [newSubGroupName, setNewSubGroupName] = useState("");
    const [groupingOptions, setGroupingOptions] = useState([]);
    const [showAddLevel3Modal, setShowAddLevel3Modal] = useState(false);
    const [newLevel3Name, setNewLevel3Name] = useState("");



    useEffect(() => {
        const mapped = groupings.map((lvl1) => ({
            fs_grp: lvl1.name,
            notes: lvl1.subgroup.map((lvl2) => ({
                note_grp: lvl2.name,
                sub: lvl2.subgroup.map((lvl3) => lvl3.name),
            })),
        }));
        setGroupingOptions(mapped);
    }, [groupings]);


    const handleGroupData = (level) => {
        if (level === "fs_grp") {
            return groupingOptions.map((o) => o.fs_grp);
        }

        if (!selectedFs) return [];

        const fsObj = groupingOptions.find((o) => o.fs_grp === selectedFs);
        if (!fsObj) return [];

        if (level === "note_grp") return fsObj.notes;
        if (level === "sub_grp") {
            const noteObj = fsObj.notes.find(
                (n) => n.note_grp === selectedNoteGroup?.note_grp
            );
            return noteObj?.sub || [];
        }

        return [];
    };


    const handleMapLedgers = async () => {
        if (!selectedFs || !selectedNoteGroup || !selectedSubGroup) return;

        const payload = {
            ledgers: selectedLedgers.map((ledger) => ({
                ledgerID: ledger._id,
                FSGroupCY: selectedFs,
                notesGroupCY: selectedNoteGroup.note_grp,
                subGroupCY: selectedSubGroup,
                FSGroupPY: selectedFs, // optional if needed
                notesGroupPY: selectedNoteGroup.note_grp,
                subGroupPY: selectedSubGroup,
            })),
        };

        try {
            const response = await mapLedger(bookClosureTbId, payload);

            dispatch(updateGroupings(response.data.updatedGroupings));
            dispatch(updateLedgers(response.data.updatedLedgers));
            console.log("Mapping successful:", payload);
            onClose();
        } catch (err) {
            console.error("Failed to map ledgers:", err);
        }
    };

    if (!show) return null;

    const handleAddLevel3 = () => {

        if (!selectedFs || !selectedNoteGroup) {
            
            swal("Please select Level 1 and Level 2 first", "", "warning");
            // alert("Please select Level 1 and Level 2 first.");
            return;
        }
        setShowAddLevel3Modal(true);
    };

    const handleSaveLevel3 = async () => {
        if (!newLevel3Name.trim()) return;

        const payload = {
            level: 3,
            levelOneName: selectedFs, // Level 1
            levelTwoName: selectedNoteGroup?.note_grp || selectedNoteGroup, // Level 2
            name: newLevel3Name, // Level 3 input
        };

        try {
            // Call your backend API
            const response = await addTBNote(bookClosureTbId,payload);
            dispatch(updateGroupings(response.data.updatedGroupings));

            // const updatedGrouping = [...groupingOptions];
            // const fsObj = updatedGrouping.find((o) => o.fs_grp === selectedFs);
            // if (fsObj) {
            //     const noteObj = fsObj.notes.find(
            //         (n) => n.note_grp === selectedNoteGroup?.note_grp || selectedNoteGroup
            //     );
            //     if (noteObj) noteObj.sub.push(newLevel3Name);
            // }

            setShowAddLevel3Modal(false);
            setNewLevel3Name("");
        } catch (err) {
            console.error("Failed to add Level 3:", err);
        }
    };




    return (
        <div className={dropdowncss.multiDropdownDiv}>
            <div className={dropdowncss.multiDropdownHead}>
                <span>Multi select Menu</span>
                <span className={commoncss.dFlex} style={{ gap: "10px" }}>
                    {(selectedFs && selectedNoteGroup && selectedSubGroup) && (
                        <CircleCheckIcon className={commoncss.clickable} onClick={handleMapLedgers} />
                    )}
                    {menu ? (
                        <DownIcon
                            className={commoncss.clickable}
                            onClick={() => setMenu(!menu)}
                        />
                    ) : (
                        <UpIcon
                            className={commoncss.clickable}
                            onClick={() => setMenu(!menu)}
                        />
                    )}
                    <CloseIcon
                        width={18}
                        height={18}
                        className={commoncss.clickable}
                        onClick={onClose}
                    />
                </span>
            </div>

            {menu && (
                <motion.div
                    className={dropdowncss.multiSelectBody}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                >
                    <div>
                        <Form.Control
                            size="lg"
                            as="select"
                            value={selectedFs}
                            onChange={(e) => setSelectedFs(e.target.value)}
                            className={dropdowncss.formSelect}
                        >
                            <option hidden value="">
                                Select FS Grouping
                            </option>
                            {handleGroupData("fs_grp")?.map((fsGrp, idx) => (
                                <option value={fsGrp} key={idx}>
                                    {fsGrp}
                                </option>
                            ))}
                        </Form.Control>
                    </div>

                    <div>
                        <Form.Control
                            size="lg"
                            as="select"
                            value={JSON.stringify(selectedNoteGroup) || ""}
                            onChange={(e) =>
                                setSelectedNoteGroup(JSON.parse(e.target.value))
                            }
                            className={dropdowncss.formSelect}
                            disabled={!selectedFs}
                        >
                            <option hidden value="">
                                Select Notes Grouping
                            </option>
                            {handleGroupData("note_grp")?.map((opt, idx) => (
                                <option key={idx} value={JSON.stringify(opt)}>
                                    {opt.note_grp}
                                </option>
                            ))}
                        </Form.Control>
                    </div>

                    <div>
                        <Form.Control
                            size="lg"
                            as="select"
                            value={selectedSubGroup}
                            onChange={(e) => setSelectedSubGroup(e.target.value)}
                            className={dropdowncss.formSelect}
                            disabled={!selectedNoteGroup}
                        >
                            <option hidden value="">
                                Select Sub Grouping
                            </option>
                            {handleGroupData("sub_grp")?.map((opt, idx) => (
                                <option key={idx} value={opt}>
                                    {opt}
                                </option>
                            ))}
                        </Form.Control>
                    </div>

                    {/* Add Level 3 */}
                    {selectedFs && selectedNoteGroup && (
                        <div className={commoncss.dFlex} style={{ gap: "5px", marginTop: "10px",justifyContent:"center" }}>
                            <div
                                className={`${commoncss.clickable} ${commoncss.dFlex} ${commoncss.fs14}`}
                                style={{ placeSelf: "center", color: "#2D8861" }}
                                onClick={handleAddLevel3}
                            >
                                <PlusIcon />&nbsp;Add Sub Grouping
                            </div>
                        </div>
                    )}
                </motion.div>
            )}
            {showAddLevel3Modal && (
                <Modal
                    title="Add Sub Group (Level 3)"
                    bodycss={commoncss.unsetPadding}
                    headerActions={
                        <CloseIcon
                            onClick={() => setShowAddLevel3Modal(false)} Name="clickable"
                        />
                    }
                    footerActions={
                        <>
                            <Button
                                btnColor={buttoncss.secondary}
                                onClick={() => setShowAddLevel3Modal(false)}
                                label="Cancel"
                            />
                            <Button
                                btnColor={buttoncss.primary}
                                label="Save"
                                onClick={handleSaveLevel3}
                            />
                        </>
                    }
                >
                    <div className={commoncss.pd1530}>
                        <InputGroup
                            label="Sub Grouping Name"
                            inputs={[
                                <>
                                    <input
                                        type="text"
                                        placeholder="Enter Sub Group name"
                                        value={newLevel3Name}
                                        onChange={(e) => setNewLevel3Name(e.target.value)}
                                    />
                                </>,
                            ]}
                        />
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default TbMultiSelect;
